export interface Tomo {
  emoji: string
  num: string
  title: string
  desc: string
}
export interface Bono {
  num: string
  title: string
  desc: string
}
export interface Testimonial {
  initials: string
  name: string
  location: string
  role: string
  quote: string
}
export interface Faq {
  q: string
  a: string
}

/** Precio único vigente de la landing. */
/**
 * Formato monetario único de la landing: siempre "AR$ 00.000".
 * Nunca añadir "ARS" cuando ya se antepone "AR$".
 */
export const PRICE = {
  previous: 'AR$ 49.990',
  current: 'AR$ 19.990',
  note: 'Pago único',
} as const

export const PRODUCT_FACTS: string[] = [
  '6 Tomos',
  '5 Bonos',
  '350+ páginas',
  'Acceso inmediato',
]

export const TOMOS: Tomo[] = [
  {
    emoji: '📘',
    num: 'Tomo 1',
    title: 'El Estudio Digital',
    desc: 'Perfil, bio, SEO local, destacadas y link de reserva.',
  },
  {
    emoji: '📗',
    num: 'Tomo 2',
    title: 'Arquitectura Visual',
    desc: 'Imagen de marca, fotografía con celular, identidad visual y feed premium.',
  },
  {
    emoji: '📙',
    num: 'Tomo 3',
    title: 'Conexión Consciente',
    desc: 'Stories, conexión diaria y venta invisible.',
  },
  {
    emoji: '📕',
    num: 'Tomo 4',
    title: 'El Método en Movimiento',
    desc: 'Reels, alcance, autoridad y posicionamiento.',
  },
  {
    emoji: '📓',
    num: 'Tomo 5',
    title: 'Ventas con Propósito',
    desc: 'Ventas por DM, objeciones y cierre de inscripciones.',
  },
  {
    emoji: '📔',
    num: 'Tomo 6',
    title: 'El Calendario Zen',
    desc: 'Planificación mensual, contenido y batching.',
  },
]

export const TOMO_FEATURES: string[] = [
  'Estrategia lista para implementar',
  'Ejemplos del mundo wellness',
  'Scripts y textos listos',
  'Checklists',
  'Ejercicios prácticos',
  'Plantillas y sistemas',
  'Casos locales',
  'Orientado a convertir seguidores en alumnos/clientes',
]

export const BONOS: Bono[] = [
  {
    num: '01',
    title: 'Scripts de Retiros y Talleres',
    desc: 'El sistema para llenar eventos presenciales y virtuales con comunicación persuasiva.',
  },
  {
    num: '02',
    title: 'WhatsApp Business para Bienestar',
    desc: 'Configuración estratégica y guiones de cierre para convertir consultas en inscripciones.',
  },
  {
    num: '03',
    title: '50 Ganchos Wellness',
    desc: 'Hooks para Reels, Posts y Stories clasificados por objetivo y sub-nicho.',
  },
  {
    num: '04',
    title: 'Iluminación y Audio Low-Cost',
    desc: 'Cómo lograr videos profesionales con celular sin invertir en equipos caros.',
  },
  {
    num: '05',
    title: 'Vencer el Miedo a la Cámara',
    desc: 'Método para comunicar con confianza y autoridad digital frente al celular.',
  },
]

export const BONOS_TOTAL = 'AR$ 43.000'

/**
 * Casos ilustrativos. Placeholders hasta contar con testimonios verificables
 * de clientes reales — reemplazar entonces por experiencias documentadas.
 */
export const TESTIMONIALS: Testimonial[] = [
  {
    initials: 'MP',
    name: 'Martina P.',
    location: 'Rosario',
    role: 'Instructora de Pilates',
    quote:
      'Con el Tomo 5 cambié por completo la forma de responder consultas. Antes mandaba el precio y se cortaba la conversación; ahora sigo una secuencia y cierro inscripciones.',
  },
  {
    initials: 'LM',
    name: 'Luciana M.',
    location: 'Buenos Aires',
    role: 'Instructora de Pilates',
    quote:
      'Con el Tomo 2 mi perfil pasó de verse improvisado a verse como un estudio premium. La misma calidad de trabajo, otra percepción profesional.',
  },
  {
    initials: 'NR',
    name: 'Natalia R.',
    location: 'Neuquén',
    role: 'Facilitadora de Meditación',
    quote:
      'El Calendario Zen me ahorra horas cada semana. Planifico todo el mes en una mañana y el resto del tiempo estoy presente para mis alumnos.',
  },
]

export const PAIN_POINTS: string[] = [
  'Domingo pensando qué subir porque la semana arranca y el perfil está vacío',
  'Respondés con el precio y el interesado desaparece sin inscribirse',
  'Tu feed se ve amateur aunque tu trabajo sea de primer nivel',
  'Tenés seguidores pero no se convierten en alumnos ni consultas reales',
]

export const FAQS: Faq[] = [
  {
    q: '¿Sirve aunque tenga pocos seguidores?',
    a: 'Sí. El sistema está diseñado exactamente para eso. El Tomo 1 optimiza el perfil para convertir visitas en consultas independientemente del número de seguidores. Con 500 seguidores bien orientados convertís más que con 5.000 sin sistema.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: '100% digital. Acceso en menos de 5 minutos después del pago. Recibirás un email con el link de descarga. Los archivos son PDF de alta calidad, listos para leer en celular, tablet o computadora.',
  },
  {
    q: '¿Necesito saber de diseño o marketing?',
    a: 'No. Todo está explicado paso a paso en lenguaje simple y directo. No necesitás conocimientos previos de marketing ni de diseño. Si sabés usar Instagram, podés implementar este sistema.',
  },
  {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días completos. Si no estás satisfecho/a, escribís a soporte@creativodigital.shop y te devolvemos el 100% sin preguntas ni formularios complicados.',
  },
]
